// Logging Manager for structured logging
export class LoggingManager {
  static initialize() {
    const isProd = typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'production';
    this.logLevel = isProd ? 'info' : 'debug';
    this.logs = [];
    this.maxLogs = 1000;
    
    // LoggingManager initialized
  }

  static setLogLevel(level) {
    this.logLevel = level;
  }

  static _shouldLog(level) {
    const levels = ['debug', 'info', 'warn', 'error'];
    return levels.indexOf(level) >= levels.indexOf(this.logLevel);
  }

  static _log(level, message, data = {}) {
    if (!this._shouldLog(level)) return;

    const logEntry = {
      timestamp: new Date().toISOString(),
      level,
      message,
      data,
      url: window.location.href,
      userAgent: navigator.userAgent
    };

    // Add to memory logs
    this.logs.push(logEntry);
    if (this.logs.length > this.maxLogs) {
      this.logs.shift();
    }

    // Console output
    const consoleMethod = console[level] || console.log;
    consoleMethod(`[${level.toUpperCase()}] ${message}`, data);

    // Send to external service in production
    const isProd = typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'production';
    if (isProd && level === 'error') {
      this._sendToExternalService(logEntry);
    }
  }

  static _sendToExternalService(logEntry) {
    // In production, send to logging service
    if (navigator.sendBeacon) {
      navigator.sendBeacon('/api/logs', JSON.stringify(logEntry));
    }
  }

  static debug(message, data = {}) {
    this._log('debug', message, data);
  }

  static info(message, data = {}) {
    this._log('info', message, data);
  }

  static warn(message, data = {}) {
    this._log('warn', message, data);
  }

  static error(message, data = {}) {
    this._log('error', message, data);
  }

  static getLogs(level = null, limit = 100) {
    let filteredLogs = this.logs;
    
    if (level) {
      filteredLogs = this.logs.filter(log => log.level === level);
    }
    
    return filteredLogs.slice(-limit);
  }

  static clearLogs() {
    this.logs = [];
  }

  static exportLogs() {
    return JSON.stringify(this.logs, null, 2);
  }
}